import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './shared/storage.service';

@Injectable({
  providedIn: 'root'
})
export class LanguajeService {
  languaje = new BehaviorSubject("en");
  constructor(private storageService: StorageService) {

    this.storageService.get('ezze_languaje').then((languaje) => {

      if(languaje){
        this.languaje.next(languaje)
      }
      else{
        this.storageService.set('ezze_languaje', "en");
      }
    });
  }
}
